// 都道府県
export type Prefecture = {
    prefecture_id: string;
    prefecture_name: string;
    select_search_string: string;
};

// 市区町村
export type City = {
    city_id: string;
    city_name: string;
    prefecture_id: string;
    select_search_string: string;
};

// /api/master/prefecture response
export type MasterPrefectureApiResponse = {
    prefecture: Array<Prefecture>;
    city: Array<City>;
};

// 初期値
export const MASTER_PREFECTURE_INIT: MasterPrefectureApiResponse = {
    prefecture: [],
    city: [],
};

// API ERROR
export const MASTER_PREFECTURE_API_ERRORS = {
    REQUEST_ERROR_9001: 'REQUEST_ERROR(9001)',
    REQUEST_ERROR_9001_STATUS_CODE: 'REQUEST_ERROR(9001)_%1',
};
